import {randItem} from '../utils.js'
import Actor from './Actor.js'

const VARIANTS = ['gateSingle', 'gateDouble', 'gateQuad']

export default class GroundObstacle extends Actor {
	constructor(imageData, sprite) {
		super(imageData)
		this.sprite = sprite !== undefined ? sprite : randItem(VARIANTS)
		// these are dynamically set by the game
		this.speed = null
		this.x = null
		this.y = null
	}

	nextFrame() {
		this.x -= this.speed
	}
}
